import _ from 'lodash'
import { Forage } from '../store/localforage'
import {
    // User related
    USERS_LOGIN_USER,
    USERS_LOGOUT_USER,
    USERS_SET_USER_PINNED_STATE,
    USERS_SET_USER_MULTILAUNCH_STATE,
    USERS_SET_USER_ACCESSTOKEN,
    USERS_SET_USER_PROFILE,
    USERS_FORGET_USERS,
    USER_SET_ORDER,

    // Ui settings related
    STEAM_SET_USED_TICKET,
} from '../constants'
import { constants as settingsConstants } from '../features/Settings'
import { constants as toasterConstants } from '../features/Toaster'

function userShouldBeStored(users, serverName, userKey) {
    if (
        users != null &&
        users.list != null &&
        users.list[serverName] != null &&
        users.list[serverName][userKey] != null
    ) {
        return (
            users.list[serverName][userKey].remember ||
            users.list[serverName][userKey].profile !== 'Default'
        )
    }
    return false
}

function updateUsers(payload, store, forceUpdate = false) {
    try {
        // Variable to keep track of users in state currently
        let stateUsers

        if (!forceUpdate) {
            // Get the users from state
            stateUsers = _.cloneDeep(store.getState().users)

            // See if the user we are dealing with is pinned
            if (!userShouldBeStored(stateUsers, payload.server, payload.userKey)) return
        }

        // If we have not already, then get the users from state
        if (stateUsers === undefined) stateUsers = _.cloneDeep(store.getState().users)

        // Generate new list of users that are pinned
        // And make sure autoLaunch is always false in localForage
        // clone.user.autoLaunch = false
        const usersToStore = _.mapValues(stateUsers.list, list =>
            _.reduce(
                list,
                (result, user, key) => {
                    if (user.remember) {
                        user.autoLaunch = false
                        result.pinned[key] = user
                    } else if (user.profile !== 'Default') {
                        result.profiled[key] = { username: key, profile: user.profile, shell: true }
                    }
                    return result
                },
                { pinned: {}, profiled: {} },
            ),
        )

        // Generate new order for users that are pinned
        const order = _.mapValues(stateUsers.order, (server, serverName) =>
            _.remove(server, user => usersToStore[serverName].pinned[user] != null),
        )

        // Generate the actual list to store
        const list = _.reduce(
            usersToStore,
            (r, v, k) => {
                r[k] = _.assign({}, v.pinned, v.profiled)
                return r
            },
            {},
        )

        // Now create a users object to store in forage
        const users = { list, order }

        // Finally save to localForage
        new Forage().setUsers(users)
    } catch (error) {
        console.info(`Couldn't update users in localforage: ${error}`)
    }
}

function forgetUsers() {
    try {
        new Forage().forgetAllUsers()
    } catch (error) {
        console.info(`Couldn't remove users from localforage: ${error}`)
    }
}

function updateUiSettings(uiSettings) {
    try {
        new Forage().setUISettings(uiSettings)
    } catch (error) {
        console.info(`Couldn't update user in localforage: ${error}`)
    }
}

function updateUsedSteamTicket(store) {
    try {
        const steam = store.getState().steam
        new Forage().setUsedSteamTicket(steam.usedTicket)
    } catch (error) {
        console.info(`Couldn't update used steam ticket in localforage: ${error.message}`)
    }
}

function updateMotds(state) {
    try {
        new Forage().setMotds(state)
    } catch (error) {
        console.info(`Couldn't update motds in localforage: ${error}`)
    }
}

const LocalForageMiddleWare = store => next => (action) => {
    switch (action.type) {
        // Always update forage in those cases
        case USERS_LOGIN_USER:
        case USERS_LOGOUT_USER:
        case USERS_SET_USER_PINNED_STATE:
        case USER_SET_ORDER: {
            const result = next(action)
            updateUsers(action.payload, store, true)
            return result
        }

        // Only update if pinned
        case USERS_SET_USER_MULTILAUNCH_STATE:
        case USERS_SET_USER_ACCESSTOKEN:
        case USERS_SET_USER_PROFILE: {
            const result = next(action)
            updateUsers(action.payload, store, false)
            return result
        }

        case USERS_FORGET_USERS: {
            const result = next(action)
            forgetUsers()
            return result
        }

        case settingsConstants.UI_SETTINGS_CHANGED: {
            const result = next(action)
            updateUiSettings(action.payload)
            return result
        }

        case STEAM_SET_USED_TICKET: {
            const result = next(action)
            updateUsedSteamTicket(store)
            return result
        }

        case toasterConstants.MOTDS_CHANGED: {
            const result = next(action)
            updateMotds(action.payload)
            return result
        }

        default:
            return next(action)
    }
}

export default LocalForageMiddleWare



// WEBPACK FOOTER //
// ./src/middlewares/LocalForageMiddleware.js